/**
 * Gekapselter Zugriff auf localStorage.
 *
 * Zwei Gruende fuer die Kapselung:
 *
 * 1. `localStorage` ist nicht immer da. In Safaris privatem Modus und
 *    bei blockierten Cookies wirft der Zugriff eine Ausnahme. Eine
 *    gemerkte Einstellung darf die App nie am Starten hindern.
 * 2. `globalThis.localStorage` ist nicht verlaesslich dasselbe wie
 *    `window.localStorage`. Node bringt inzwischen ein eigenes,
 *    experimentelles Global mit, das ohne Startparameter nicht
 *    verfuegbar ist -- in Tests greift man damit ins Leere.
 */
function store(): Storage | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function readSetting(key: string): string | null {
  try {
    return store()?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeSetting(key: string, value: string): void {
  try {
    store()?.setItem(key, value);
  } catch {
    // Einstellung gilt dann nur fuer diese Sitzung.
  }
}

export function removeSetting(key: string): void {
  try {
    store()?.removeItem(key);
  } catch {
    // Nicht kritisch.
  }
}
